<template>
    <div class="loginInput">
        <input :type="iParam.type" :placeholder="iParam.placeholder" v-model="iParam.value" :maxlength="iParam.len" @blur="trimAll(iParam.value)">
        <span class="clear" v-show="iParam.value.length > 0" @click="clear"></span>
        <slot></slot>
    </div>
</template>

<script>

export default {
    data() {
        return {
        }
    },
    props: {
        iParam: {
            type: Object,
            default() {
                return {}
            }
        },
    },
  async mounted() {
  },
  watch: {
  },
  computed: {
  },
  methods: {
    clear() {
        this.$emit('resetVal')
    },
    trimAll(v) {
        const _v = v.trim()
        this.$emit('trimAll', _v)
    }
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.loginInput {
    z-index: 19;
    position: relative;
    height: 44px;
    margin-bottom: 20px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    background: #fff;
    font-size: 14px;
    line-height: 44px;
    display: flex;
    justify-content: space-between;

    input {
        flex: 1;
        height: 38px;
        font-size: 14px;
        margin: 2px 0;
        padding: 0 20px 0 10px;
        color: #333;
        border: 0;
        outline: none;
    }

    .clear{
        display: block;
        width: 18px;
        height: 100%;
        background: url("../../../assets/images/icon-x.png") no-repeat center;
        background-size: 18px;
        margin-right: 8px;
    }

    img {
        width: 18px;
        height: 18px;
        margin: 13px 10px 0 0;
    }
}

</style>
